import { cli } from '@kidd-cli/core'

import { readCLIManifest } from './manifest.js'

const [manifestError, manifest] = await readCLIManifest(import.meta.dirname)
if (manifestError) {
  console.error(manifestError.message)
  process.exit(1)
}

await cli({
  commands: `${import.meta.dirname}/commands`,
  description: manifest.description,
  help: { header: `kidd v${manifest.version}` },
  name: 'kidd',
  version: manifest.version,
})
